export default "__VITE_ASSET__CX6BTkjx__"